
const language = {
    'pt':
    {
        //////
        editar_dados: 'Editar dados',
        meus_dados: 'Os Meus Dados',
        overview: 'Visão Geral',
        settings: 'Configurações',
        carregar_cv: 'Carregar CV',

        /////
        tag: 'Código',
        add_new: 'Adicionar novo',
        birthday: 'Data de nascimento',
        cancel: 'Cancelar', back: 'Voltar',
        close: 'Fechar',
        config: 'Configuração',
        content: 'Conteúdo',
        content_edit: 'Editar conteúdo',
        content_new: 'Novo conteúdo',
        content_list: 'Lista de conteúdos',
        country: 'País',
        country_placeholder: 'Introduza o país',
        city: 'Cidade',
        city_placeholder: 'Introduza a cidade',
        district: 'Distrito',
        district_placeholder: 'Introduza o distrito',
        dados_pessoais: 'Dados Pessoais',
        local: 'Localidade',
        local_placeholder: 'Introduza a localidade',
        morada: 'Morada',
        morada_placeholder: 'Introduza a morada',
        postal_code: 'Código-postal',
        postal_code_placeholder: 'Introduza o código-postal',
        village: 'Freguesia',
        village_placeholder: 'Introduza a freguesia',
        dark_mode: 'Dark mode',
        dates: 'Datas',
        date_creation: 'Criação',
        date_publication: 'Publicação',
        date_last_update: 'Última actualização',
        delete: 'Eliminar',
        delete_title: 'Eliminar Registo',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        description: 'Descrição',
        description_placeholder: 'Introduza uma descrição',
        doc_choose:         'Escolher PDF',
        edit: 'Editar',
        edit_title: 'Editar Registo',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_confirm: 'Sim',
        edit_cancel: 'Não',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        email: 'E-mail',
        email_placeholder: 'Introduza o e-mail',
        entity: 'Cliente',
        entity_edit: 'Editar cliente',
        entity_new: 'Novo cliente',
        entity_list: 'Lista de clientes',
        filter_placeholder: 'Procurar',
        id: 'ID',
        language: 'Lingua',
        login_data: 'Dados de Login',
        name: 'Nome',
        name_placeholder: 'Introduza o nome',
        vat: 'NIF',
        vat_placeholder: 'Introduza o NIF',
        identification_number_type: 'Tipo de identificação',
        identification_number: 'Número de identificação',
        identification_number_placeholder: 'Introduza o número de identificação',
        identification_validation: 'Validade',
        choose: 'Escolha uma opção',
        cc: 'Cartão de Cidadão',
        passaporte: 'Passaporte',
        bi: 'Bilhete de Identidade',
        autorizacao_residencia: 'Autorização de Residência',
        image: 'Imagem',
        image_choose: 'Escolher imagem',
        insert_title: 'Novo Registo',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_confirm: 'Sim',
        insert_cancel: 'Não',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        password: 'Password',
        password_confirmation: 'Confirmação da Password',
        password_placeholder: 'Introduza a password',
        password_title: 'Password!',
        password_text: 'As Passwords não correspondem.',
        password_confirm: 'Continue',
        password_cancel: 'No',
        password_error: 'Problem inserting element!',
        password_success: 'Successful inserted element!',
        personal_data: 'Dados pessoais',
        principal: 'Principal',
        profile: 'Perfil',
        remove: 'Remover',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_all: 'Todos',
        table_thumbnail: 'Thumbnail',
        table_title: 'Título',
        table_parent: 'Parent',
        table_date: 'Data',
        table_type: 'Tipo',
        table_count: 'Count',
        table_state: 'Estado',
        table_actions: 'Acções',
        table_empty: 'sem resultados',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        tlf: 'Telefone',
        tlf_placeholder: 'Introduza o número de telefone',
        tlm: 'Telemóvel',
        tlm_placeholder: 'Introduza o número de telemóvel',
        type: 'Tipo de cliente',
        type_placeholder: 'Introduza o tipo de cliente',
        type_identification: 'Tipo de identificação',
        type_identification_placeholder: 'Introduza o tipo de identificação',
        save: 'Salvar',
        username: 'Username',
        username_placeholder: 'Introduza o username',
        warning_title: 'Aviso!',
        warning_text: 'O username já existe no sistema.',
        warning_confirm: 'Continuar',
        warning_cancel: 'Não',
        warning_error: 'Problema ao inserir registo!',
        warning_success: 'Registo inserido com sucesso!',
        fotografia: ' Fotografia',
        photo: 'Carregar Foto',
        noPhoto: 'Sem foto',
        naturalidade: 'Naturalidade',
        naturalidade_placeholder: 'Introduza a naturalidade',
        nacionalidade: 'Nacionalidade',
        nacionalidade_placeholder: 'Introduza a nacionalidade',
        relacao: 'Relação',
        contact: 'Contacto',
        sports_data: 'Dados Desportivos',
        parents_data: 'Pais e Encarregados de Educação',
        carregar_exame_medico:  'Carregar exame médico',
        function: 'Função',

        dirigente: 'Dirigente',
        praticante: 'Praticante',
        treinador: 'Treinador',
        outros: 'Outros',

        clube: 'Clube',
        modalidade: 'Modalidade',
        outras_modalidades: 'Outras modalidades',
        numero_licenca: 'Número de Licença',

        pais_encarregados: 'Pais e Encarregados de Educação',
        nome_contacto_pai: 'Nome e Contacto do Pai',
        nome_contacto_mae: 'Nome e Contacto da Mãe',
        nome_contacto_encarregado: 'Nome e Contacto do Encarregado de Educação',

        seguro_opcional: 'Seguro opcional',
        federado_outras_modalidades: 'Se federados noutras federações? Indique qual ou quais.',

        data_emissao_exame_medico: 'Data de Emissão do Exame Médico',
        download: 'Descarregar PDF',

		profissao: 'Profissão',
		profissao_placeholder: 'Se for estudante, preencha "Estudante"',
		empresa: 'Empresa',
		estabelecimento_ensino: 'Estabelecimento de ensino (Se Estudante)',
        genero: 'Género',
        observation: 'Observações e situações especiais',
        choose_option: 'Escolha um apção',

        pay_fee: 'Pagar inscrição',
        escalao:    'Escalão',

        cancel:                     'Cancelar',
        back:                       'Voltar',
        confirm_purchase_cancel:    'Cancelar finalização',
        confirm_purchase_confirm:   'Finalizar',
        confirm_purchase_error:     'Erro a processar a inscrição.',
        confirm_purchase_success:   'Inscrição processada com sucesso.',
        confirm_purchase_text:      'Pretende finalizar a inscrição?',
        confirm_purchase_title:     'Confirmar inscrição',

        confirm_login_error:        'O registo é obrigatório.',
        confirm_form_error:         'Os campos assinalados com (*) são de preenchimento obrigatório. O endereço de email permite um contacto mais rápido em caso de necessidade de esclarecimentos adicionais. A informação que submeter não será usada ou distribuída por outra razão que não o processamento do seu pedido.',
        confirm_agree_error:        'Tem de ler e aceitar os termos e condições para finalizar a compra.',

        encomenda_finalizada:       'Inscrição registada com sucesso, consulte o seu e-mail para finalizar a inscrição com sucesso!',
        encomenda_finalizada_attention: 'Atenção',
        encomenda_finalizada_attention_txt: 'O email pode ir para SPAM.',
        encomenda_finalizada_free:  'Inscrição registada com sucesso!',

        dados_tipo_pagamento:       'Tipo de pagamento',
        valor_a_pagar:              'Valor a pagar',

        tb_iban:                    'IBAN',
        tb_attention:               'Atenção',
        tb_details:                 'Na descrição da tranferência deve constar o nome do atleta.',

    },
    'en':
    {
        overview: 'Overview',
        settings: 'Settings',
        carregar_cv: 'Load CV',
        editar_dados: 'Edit Data',
        photo: 'Load Profile Photo',
        noPhoto: 'No photo',
        tag: 'Code',
        meus_dados: 'My Data',
        dados_pessoais: 'Personal Data',
        add_new: 'Add new',
        birthday: 'Date of birth',
        cancel: 'Cancel',
        close: 'Close',
        config: 'Configuration',
        content: 'Content',
        content_edit: 'Edit content',
        content_new: 'New content',
        content_list: 'Content list',
        country: 'Country',
        country_placeholder: 'Enter the country',
        city: 'City',
        city_placeholder: 'Enter the city',
        district: 'District',
        district_placeholder: 'Enter the district',
        local: 'Locality',
        local_placeholder: 'Enter the locality',
        morada: 'Address',
        morada_placeholder: 'Enter the address',
        postal_code: 'Postal code',
        postal_code_placeholder: 'Enter the postal code',
        village: 'Parish',
        village_placeholder: 'Enter the parish',
        dark_mode: 'Dark mode',
        dates: 'Dates',
        date_creation: 'Creation',
        date_publication: 'Publication',
        date_last_update: 'Last update',
        delete: 'Delete',
        delete_title: 'Delete Record',
        delete_text: 'Are you sure you want to proceed?',
        delete_confirm: 'Yes',
        delete_cancel: 'No',
        delete_error: 'Problem deleting record!',
        delete_success: 'Record deleted successfully!',
        description: 'Description',
        description_placeholder: 'Enter a description',
        doc_choose:         'Escolher PDF',
        edit: 'Edit',
        edit_title: 'Edit Record',
        edit_text: 'Are you sure you want to proceed?',
        edit_confirm: 'Yes',
        edit_cancel: 'No',
        edit_error: 'Problem updating record!',
        edit_success: 'Record updated successfully!',
        email: 'E-mail',
        email_placeholder: 'Enter the e-mail',
        entity: 'Client',
        entity_edit: 'Edit client',
        entity_new: 'New client',
        entity_list: 'Client list',
        filter_placeholder: 'Search',
        id: 'ID',
        language: 'Language',
        login_data: 'Login Data',
        name: 'Name',
        name_placeholder: 'Enter the name',
        vat: 'VAT',
        vat_placeholder: 'Enter the VAT',
        identification_number: 'Identification number',
        identification_number_placeholder: 'Enter the identification number',
        identification_validation: 'Validation',
        image: 'Image',
        image_choose: 'Choose image',
        insert_title: 'New Record',
        insert_text: 'Are you sure you want to proceed?',
        insert_confirm: 'Yes',
        insert_cancel: 'No',
        insert_error: 'Problem inserting record!',
        insert_success: 'Record inserted successfully!',
        password: 'Password',
        password_confirmation: 'Password Confirmation',
        password_placeholder: 'Enter the password',
        password_title: 'Password!',
        password_text: 'Passwords do not match.',
        password_confirm: 'Continue',
        password_cancel: 'No',
        password_error: 'Problem inserting element!',
        password_success: 'Element inserted successfully!',
        personal_data: 'Personal data',
        principal: 'Principal',
        profile: 'Profile',
        remove: 'Remove',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_all: 'All',
        table_thumbnail: 'Thumbnail',
        table_title: 'Title',
        table_parent: 'Parent',
        table_date: 'Date',
        table_type: 'Type',
        table_count: 'Count',
        table_state: 'State',
        table_actions: 'Actions',
        table_empty: 'no results',
        text: 'Text',
        title: 'Title',
        title_placeholder: 'Enter the title',
        tlf: 'Phone',
        tlf_placeholder: 'Enter the phone number',
        tlm: 'Mobile phone',
        tlm_placeholder: 'Enter the mobile phone number',
        type: 'Client type',
        type_placeholder: 'Enter the client type',
        type_identification: 'Identification type',
        type_identification_placeholder: 'Enter the identification type',
        save: 'Save',
        username: 'Username',
        username_placeholder: 'Enter the username',
        warning_title: 'Warning!',
        warning_text: 'The username already exists in the system.',
        warning_confirm: 'Continue',
        warning_cancel: 'No',
        warning_error: 'Problem inserting record!',
        warning_success: 'Record inserted successfully!',
    },
    'es': {
        add_new: 'Agregar nuevo',
        birthday: 'Fecha de nacimiento',
        cancel: 'Cancelar', back: 'Voltar',
        close: 'Cerrar',
        config: 'Configuración',
        content: 'Contenido',
        content_edit: 'Editar contenido',
        content_new: 'Nuevo contenido',
        content_list: 'Lista de contenidos',
        country: 'País',
        country_placeholder: 'Introduzca el país',
        city: 'Ciudad',
        city_placeholder: 'Introduzca la ciudad',
        district: 'Distrito',
        district_placeholder: 'Introduzca el distrito',
        local: 'Localidad',
        local_placeholder: 'Introduzca la localidad',
        morada: 'Dirección',
        morada_placeholder: 'Introduzca la dirección',
        postal_code: 'Código postal',
        postal_code_placeholder: 'Introduzca el código postal',
        village: 'Parroquia',
        village_placeholder: 'Introduzca la parroquia',
        dark_mode: 'Modo oscuro',
        dates: 'Fechas',
        date_creation: 'Creación',
        date_publication: 'Publicación',
        date_last_update: 'Última actualización',
        delete: 'Eliminar',
        delete_title: 'Eliminar Registro',
        delete_text: '¿Está seguro de que desea continuar?',
        delete_confirm: 'Sí',
        delete_cancel: 'No',
        delete_error: '¡Problema al eliminar registro!',
        delete_success: '¡Registro eliminado con éxito!',
        description: 'Descripción',
        description_placeholder: 'Introduzca una descripción',
        doc_choose:         'Escolher PDF',
        edit: 'Editar',
        edit_title: 'Editar Registro',
        edit_text: '¿Está seguro de que desea continuar?',
        edit_confirm: 'Sí',
        edit_cancel: 'No',
        edit_error: '¡Problema al actualizar registro!',
        edit_success: '¡Registro actualizado con éxito!',
        email: 'Correo electrónico',
        email_placeholder: 'Introduzca el correo electrónico',
        entity: 'Cliente',
        entity_edit: 'Editar cliente',
        entity_new: 'Nuevo cliente',
        entity_list: 'Lista de clientes',
        filter_placeholder: 'Buscar',
        id: 'ID',
        language: 'Idioma',
        login_data: 'Datos de inicio de sesión',
        name: 'Nombre',
        name_placeholder: 'Introduzca el nombre',
        vat: 'NIF',
        vat_placeholder: 'Introduzca el NIF',
        identification_number: 'Número de identificación',
        identification_number_placeholder: 'Introduzca el número de identificación',
        identification_validation: 'Validez',
        image: 'Imagen',
        image_choose: 'Elegir imagen',
        insert_title: 'Nuevo Registro',
        insert_text: '¿Está seguro de que desea continuar?',
        insert_confirm: 'Sí',
        insert_cancel: 'No',
        insert_error: '¡Problema al insertar registro!',
        insert_success: '¡Registro insertado con éxito!',
        password: 'Contraseña',
        password_confirmation: 'Confirmación de contraseña',
        password_placeholder: 'Introduzca la contraseña',
        password_title: '¡Contraseña!',
        password_text: 'Las contraseñas no coinciden.',
        password_confirm: 'Continuar',
        password_cancel: 'No',
        password_error: '¡Problema al insertar elemento!',
        password_success: '¡Elemento insertado con éxito!',
        personal_data: 'Datos personales',
        principal: 'Principal',
        profile: 'Perfil',
        remove: 'Eliminar',
        table_rows_per_page: 'Registros por página:',
        table_separator: 'de',
        table_all: 'Todos',
        table_thumbnail: 'Miniatura',
        table_title: 'Título',
        table_parent: 'Principal',
        table_date: 'Fecha',
        table_type: 'Tipo',
        table_count: 'Cantidad',
        table_state: 'Estado',
        table_actions: 'Acciones',
        table_empty: 'sin resultados',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introduzca el título',
        tlf: 'Teléfono',
        tlf_placeholder: 'Introduzca el número de teléfono',
        tlm: 'Teléfono móvil',
        tlm_placeholder: 'Introduzca el número de teléfono móvil',
        type: 'Tipo de cliente',
        type_placeholder: 'Introduzca el tipo de cliente',
        type_identification: 'Tipo de identificación',
        type_identification_placeholder: 'Introduzca el tipo de identificación',
        save: 'Guardar',
        username: 'Usuario',
        username_placeholder: 'Introduzca el usuario',
        warning_title: '¡Advertencia!',
        warning_text: 'El usuario ya existe en el sistema.',
        warning_confirm: 'Continuar',
        warning_cancel: 'No',
        warning_error: '¡Problema al insertar registro!',
        warning_success: '¡Registro insertado con éxito!',

    },
    'fr': {
        add_new: 'Ajouter nouveau',
        birthday: 'Date de naissance',
        cancel: 'Annuler',
        close: 'Fermer',
        config: 'Configuration',
        content: 'Contenu',
        content_edit: 'Modifier le contenu',
        content_new: 'Nouveau contenu',
        content_list: 'Liste des contenus',
        country: 'Pays',
        country_placeholder: 'Entrez le pays',
        city: 'Ville',
        city_placeholder: 'Entrez la ville',
        district: 'District',
        district_placeholder: 'Entrez le district',
        local: 'Localité',
        local_placeholder: 'Entrez la localité',
        morada: 'Adresse',
        morada_placeholder: 'Entrez l’adresse',
        postal_code: 'Code postal',
        postal_code_placeholder: 'Entrez le code postal',
        village: 'Commune',
        village_placeholder: 'Entrez la commune',
        dark_mode: 'Mode sombre',
        dates: 'Dates',
        date_creation: 'Création',
        date_publication: 'Publication',
        date_last_update: 'Dernière mise à jour',
        delete: 'Supprimer',
        delete_title: 'Supprimer l’Enregistrement',
        delete_text: 'Êtes-vous sûr de vouloir continuer ?',
        delete_confirm: 'Oui',
        delete_cancel: 'Non',
        delete_error: 'Problème lors de la suppression de l’enregistrement !',
        delete_success: 'Enregistrement supprimé avec succès !',
        description: 'Description',
        description_placeholder: 'Entrez une description',
        doc_choose:         'Escolher PDF',
        edit: 'Modifier',
        edit_title: 'Modifier l’Enregistrement',
        edit_text: 'Êtes-vous sûr de vouloir continuer ?',
        edit_confirm: 'Oui',
        edit_cancel: 'Non',
        edit_error: 'Problème lors de la mise à jour de l’enregistrement !',
        edit_success: 'Enregistrement mis à jour avec succès !',
        email: 'E-mail',
        email_placeholder: 'Entrez l’e-mail',
        entity: 'Client',
        entity_edit: 'Modifier le client',
        entity_new: 'Nouveau client',
        entity_list: 'Liste des clients',
        filter_placeholder: 'Rechercher',
        id: 'ID',
        language: 'Langue',
        login_data: 'Données de connexion',
        name: 'Nom',
        name_placeholder: 'Entrez le nom',
        vat: 'TVA',
        vat_placeholder: 'Entrez le numéro de TVA',
        identification_number: 'Numéro d’identification',
        identification_number_placeholder: 'Entrez le numéro d’identification',
        identification_validation: 'Validité',
        image: 'Image',
        image_choose: 'Choisir une image',
        insert_title: 'Nouvel Enregistrement',
        insert_text: 'Êtes-vous sûr de vouloir continuer ?',
        insert_confirm: 'Oui',
        insert_cancel: 'Non',
        insert_error: 'Problème lors de l’insertion de l’enregistrement !',
        insert_success: 'Enregistrement inséré avec succès !',
        password: 'Mot de passe',
        password_confirmation: 'Confirmation du mot de passe',
        password_placeholder: 'Entrez le mot de passe',
        password_title: 'Mot de passe !',
        password_text: 'Les mots de passe ne correspondent pas.',
        password_confirm: 'Continuer',
        password_cancel: 'Non',
        password_error: 'Problème lors de l’insertion de l’élément !',
        password_success: 'Élément inséré avec succès !',
        personal_data: 'Données personnelles',
        principal: 'Principal',
        profile: 'Profil',
        remove: 'Retirer',
        table_rows_per_page: 'Enregistrements par page :',
        table_separator: 'de',
        table_all: 'Tous',
        table_thumbnail: 'Miniature',
        table_title: 'Titre',
        table_parent: 'Parent',
        table_date: 'Date',
        table_type: 'Type',
        table_count: 'Nombre',
        table_state: 'État',
        table_actions: 'Actions',
        table_empty: 'aucun résultat',
        text: 'Texte',
        title: 'Titre',
        title_placeholder: 'Entrez le titre',
        tlf: 'Téléphone',
        tlf_placeholder: 'Entrez le numéro de téléphone',
        tlm: 'Téléphone mobile',
        tlm_placeholder: 'Entrez le numéro de téléphone mobile',
        type: 'Type de client',
        type_placeholder: 'Entrez le type de client',
        type_identification: 'Type d’identification',
        type_identification_placeholder: 'Entrez le type d’identification',
        save: 'Sauvegarder',
        username: 'Nom d’utilisateur',
        username_placeholder: 'Entrez le nom d’utilisateur',
        warning_title: 'Attention !',
        warning_text: 'Le nom d’utilisateur existe déjà dans le système.',
        warning_confirm: 'Continuer',
        warning_cancel: 'Non',
        warning_error: 'Problème lors de l’insertion de l’enregistrement !',
        warning_success: 'Enregistrement inséré avec succès !',
    }
}

module.exports = {
    language
};